import { supabase } from './supabase';
import { topicoComandosTela } from './canaisTela';

export interface CanalTelaEvento {
  event:   string;
  payload: Record<string, unknown>;
}

/**
 * Envia múltiplos broadcasts em sequência no canal `cmd_tela_{telaId}` (privado).
 *
 * `supabase.channel(topic)` devolve a MESMA instância se o tópico já existe
 * (dedupe no @supabase/realtime-js) — p.ex. o canal de comandos de longa
 * duração do Controle Remoto. Por isso:
 *   - canal já `joined` → envia pelo WebSocket dele;
 *   - qualquer outro estado → envia por REST (`httpSend`, sem subscribe) e
 *     só remove o canal se foi criado aqui.
 * Antes, um canal alheio em `joining` (reconexão) recebia um `subscribe()`
 * que a lib ignora; após 8 s de timeout o cleanup removia o canal do dono.
 */
export async function enviarBroadcastsCanalTela(
  telaId:  string,
  eventos: CanalTelaEvento[],
): Promise<void> {
  const topico   = topicoComandosTela(telaId);
  const jaExiste = supabase.getChannels().some(c => c.topic === `realtime:${topico}`);
  const canal    = supabase.channel(topico, { config: { private: true } });

  if (canal.state === 'joined') {
    for (const { event, payload } of eventos) {
      await canal.send({ type: 'broadcast', event, payload });
    }
    return;
  }

  try {
    for (const { event, payload } of eventos) {
      await canal.httpSend(event, payload);
    }
  } finally {
    if (!jaExiste) await supabase.removeChannel(canal);
  }
}

/** Envia um único broadcast no canal `cmd_tela_{telaId}` (privado) (subscribe-before-send). */
export async function enviarBroadcastCanalTela(
  telaId:  string,
  event:   string,
  payload: Record<string, unknown>,
): Promise<void> {
  return enviarBroadcastsCanalTela(telaId, [{ event, payload }]);
}
